module.exports = __webpack_public_path__ + "static/media/BW.58014cd6.PNG";